module.exports = __webpack_public_path__ + "img/tours_4.57744372.jpg";